var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let MdsDataplaneResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.mds);
    __publicField(this, "apiVersion", "2019-11-01-preview");
  }
  getExperimentationGroups(workspaceId) {
    return __async(this, null, function* () {
      const workspace = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      const address = `/workspaces/${workspace}/experimentationGroups?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getExperimentationGroupById(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getRootExperimentationGroup(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getExperimentationGroupRootPath(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      result.ensureSuccess();
      return result.getSuccessData().Path;
    });
  }
  getAnalysisRules(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getAnalysisRule(workspaceId, analysisRuleName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  deleteAnalysisRule(workspaceId, analysisRuleName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._delete(address);
    });
  }
  deleteAnalysisRules(workspaceId, analysisRuleNames) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules?apiversion=${this.apiVersion}`;
      return yield this._delete(address, analysisRuleNames);
    });
  }
  createOrUpdateAnalysisRule(workspaceId, analysisRuleName, analysisRule) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._put(analysisRule, address);
    });
  }
};
MdsDataplaneResources = __decorateClass([
  WPSProxyConverter()
], MdsDataplaneResources);
const DataplaneResource = new MdsDataplaneResources();
export {
  MdsDataplaneResources,
  DataplaneResource as default
};
//# sourceMappingURL=DataplaneResources.js.map
